<section class="page-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin Social Links</span>
        <h1>Manage social media links.</h1>
        <p>Edit LinkedIn, Facebook, Instagram, YouTube and email links used on the website.</p>
    </div>
</section>

<section class="section">
    <div class="container">

        <div style="margin-bottom:24px">
            <a class="learn" routerLink="/admin/dashboard">← Back to dashboard</a>
        </div>

        <div *ngIf="successMessage" class="alert success" style="margin-bottom:16px">
            {{ successMessage }}
        </div>

        <div *ngIf="errorMessage" class="alert error" style="margin-bottom:16px">
            {{ errorMessage }}
        </div>

        <div class="contact-grid">

            <main class="quote-panel">
                <span class="section-kicker">Social Link Form</span>
                <h2 style="font-size:32px;margin-top:8px">
                    {{ model.id === 0 ? 'New Social Link' : 'Edit Social Link' }}
                </h2>

                <div class="form-grid">

                    <div class="field">
                        <label>Name</label>
                        <input [(ngModel)]="model.name" name="socialName" placeholder="LinkedIn">
                    </div>

                    <div class="field">
                        <label>Icon Key</label>
                        <select [(ngModel)]="model.iconKey" name="socialIconKey">
                            <option value="">Select icon</option>
                            <option *ngFor="let key of iconKeys" [value]="key">
                                {{ key }}
                            </option>
                        </select>
                    </div>

                    <div class="field full">
                        <label>URL</label>
                        <input [(ngModel)]="model.url" name="socialUrl" placeholder="https://linkedin.com/company/...">
                    </div>

                    <div class="field">
                        <label>Sort</label>
                        <input type="number" [(ngModel)]="model.sort" name="socialSort">
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="model.status" name="socialStatus">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field full" style="display:flex;gap:10px;flex-direction:row">
                        <button class="btn btn-primary" type="button" (click)="saveLink()" [disabled]="saving">
                            {{ saving ? 'Saving...' : 'Save Link' }}
                        </button>

                        <button class="btn btn-ghost" type="button" (click)="newLink()">
                            Clear
                        </button>
                    </div>

                </div>
            </main>

            <aside>
                <span class="section-kicker">Social Links</span>
                <h2 style="font-size:34px">Current links.</h2>

                <div *ngIf="loading">Loading social links...</div>

                <div class="office-card premium-office" *ngFor="let s of links">
                    <h3>{{ s.name }}</h3>
                    <p>{{ s.url || '-' }}</p>

                    <span>
                        {{ s.iconKey }} /
                        {{ s.status ? 'Active' : 'Hidden' }} /
                        Sort {{ s.sort }}
                    </span>

                    <div style="display:flex;gap:8px;margin-top:14px">
                        <button class="btn btn-ghost" type="button" (click)="editLink(s)">
                            Edit
                        </button>

                        <button class="btn btn-dark" type="button" (click)="deleteLink(s.id)">
                            Delete
                        </button>
                    </div>
                </div>

                <div *ngIf="!loading && links.length === 0" style="padding:20px 0">
                    No social links found.
                </div>
            </aside>

        </div>

    </div>
</section>